"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicItemSortField = exports.SubscriptionPlanPeriodUnit = exports.SortDirection = exports.Make = exports.ItemSortField = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["Boolean"] = "boolean";
    ComponentType["Datetime"] = "datetime";
    ComponentType["SingleLine"] = "singleLine";
    ComponentType["RichText"] = "richText";
    ComponentType["Images"] = "images";
    ComponentType["ItemRelations"] = "itemRelations";
    ComponentType["Location"] = "location";
    ComponentType["ParagraphCollection"] = "paragraphCollection";
    ComponentType["PropertiesTable"] = "propertiesTable";
    ComponentType["Videos"] = "videos";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var ItemSortField;
(function (ItemSortField) {
    ItemSortField["TreePosition"] = "treePosition";
})(ItemSortField = exports.ItemSortField || (exports.ItemSortField = {}));
var Make;
(function (Make) {
    Make["Mercedes"] = "Mercedes";
    Make["Volkswagen"] = "Volkswagen";
    Make["Saab"] = "Saab";
    Make["Scania"] = "Scania";
    Make["Citroen"] = "Citroen";
    Make["Kia"] = "Kia";
    Make["Peugeot"] = "Peugeot";
    Make["Ds"] = "DS";
    Make["Smart"] = "Smart";
    Make["Opel"] = "Opel";
})(Make = exports.Make || (exports.Make = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var SubscriptionPlanPeriodUnit;
(function (SubscriptionPlanPeriodUnit) {
    SubscriptionPlanPeriodUnit["Day"] = "day";
    SubscriptionPlanPeriodUnit["Week"] = "week";
    SubscriptionPlanPeriodUnit["Month"] = "month";
    SubscriptionPlanPeriodUnit["Year"] = "year";
})(SubscriptionPlanPeriodUnit = exports.SubscriptionPlanPeriodUnit || (exports.SubscriptionPlanPeriodUnit = {}));
var TopicItemSortField;
(function (TopicItemSortField) {
    TopicItemSortField["CreatedAt"] = "createdAt";
})(TopicItemSortField = exports.TopicItemSortField || (exports.TopicItemSortField = {}));
//# sourceMappingURL=core-api.js.map